export default [
  {
    title: 'Home',
    route: 'Posts',
    icon: 'MapIcon',
    perfil_id: [1, 7, 8, 20, 12],
  },
  {
    title: 'Flow',
    route: 'list-flow',
    icon: 'RepeatIcon',
    perfil_id: [1, 7, 8, 11, 12, 20,],
    children: [

      {
        title: 'Solicitações',
        route: 'list-flow',
        perfil_id: [1, 7, 8, 11, 12, 20],
      },

      {
        title: 'Aprovações',
        route: 'flow-approvals',
        perfil_id: [1, 7, 8, 11, 12, 20],
      },
      {
        title: 'Minhas solicitções',
        route: 'flow-my',
        perfil_id: [1, 7, 8, 11, 12, 20],
      },
      {
        title: 'Modelos de Flow',
        route: 'flow-templates',
        perfil_id: [1, 7, 8, 11, 12, 20],
      },
      {
        title: 'Modelos de Formulário',
        route: 'form-templates',
        perfil_id: [1, 7, 8, 11, 12, 20],
      },

    ]

  },
  {
    title: 'Fechamento Cards',
    route: 'list-graphics',
    icon: 'ActivityIcon',
    perfil_id: [8],
  },
  {
    title: 'Fechamento Chamados',
    route: 'list-graphic-tickets',
    icon: 'PieChartIcon',
    perfil_id: [8],
  },
  {
    title: 'Relatórios',
    route: 'list-reports',
    icon: 'BarChart2Icon',
    perfil_id: [8],
  },
  {
    title: 'Reembolsos',
    icon: 'DollarSignIcon',
    perfil_id: [1, 2, 6, 7, 8, 20, 12],
    children: [
      {
        title: 'Solicitações',
        route: 'list-reimbursement-solicitations',
        perfil_id: [1, 7, 8, 20, 12],
      },
      {
        title: 'Adiantamentos',
        route: 'list-advances',
        // Qualquer nível interno pode solicitar adiantamento (Cliente e Terceiro não)
        perfil_id: [1, 2, 6, 7, 8, 12, 20],
      },
    ]
  },
  {
    title: 'Dasp',
    route: 'list-dasps',
    icon: 'FileIcon',
    perfil_id: [1, 7, 8, 20, 12],
  },
  {
    title: 'Chamados',
    icon: 'MailIcon',
    route: 'list-calls',
    perfil_id: [1, 7, 8, 10, 20, 12],
    children: [
      {
        title: 'Todos Chamados',
        route: 'list-calls',
        perfil_id: [1, 7, 8, 10, 20, 12],
      },
      {
        title: 'Finalizados e Cancelados',
        route: 'list-calls-finish-cancels',
        perfil_id: [1, 7, 8, 10, 20, 12],
      },
      {
        title: 'Meus Chamados',
        route: 'list-my-calls',
        perfil_id: [1, 7, 8, 10, 20, 12],
      },
      {
        title: 'Monitoração',
        route: 'list-monitorings',
        perfil_id: [1, 7, 8, 10, 20, 12],
      },

    ]
  },
  {
    title: 'Pipeline',
    icon: 'UploadCloudIcon',
    route: 'list-deploys',
    perfil_id: [1, 7, 8, 10, 20, 12],
  },
  {
    title: 'Tarefas',
    icon: 'ToolIcon',
    route: 'list-tasks',
    perfil_id: [1, 7, 8, 11, 20, 12],
  },
  {
    title: 'Daily',
    route: 'list-dailies',
    icon: 'GitPullRequestIcon',
    perfil_id: [1, 7, 8, 20, 12],
    isDaily: true,
  },
  {
    title: 'Escalas',
    route: 'list-home_offices',
    icon: 'CommandIcon',
    perfil_id: [1, 7, 8, 20, 12],
  },
  {
    title: 'Calendário',
    route: 'calendario',
    icon: 'CalendarIcon',
    perfil_id: [1, 7, 8, 20, 12],
  },
  {
    title: 'Estoque',    
    icon: 'BoxIcon',
    perfil_id: [7, 8, 12],
    children: [
      {
        title: 'Estoque',
        route: 'list-stock',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Movimentações',
        route: 'list-stock-movements',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Categorias de Produto',
        route: 'list-product-categories',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Fornecedores',
        route: 'list-suppliers',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Fabricantes',
        route: 'list-manufacturers',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Modelos de Produto',
        route: 'list-product-models',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Unidades dos Clientes',
        route: 'list-client-units',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Produtos',
        route: 'list-products',
        perfil_id: [7, 8, 12],
      },
    ]
  },
  {
    title: 'Cadastros',
    icon: 'PlusSquareIcon',
    perfil_id: [1, 7, 8, 20, 12],
    children: [
      {
        title: 'Aquisições',
        route: 'list-acquisitions',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Centro de Custos',
        route: 'list-bill_centers',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Clientes',
        route: 'list-clients',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Contatos dos Clientes',
        route: 'list-client-contacts',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Departamentos',
        route: 'list-departments',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Grupos de Custos',
        route: 'list-groups',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Equipes',
        route: 'list-teams',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Tipos de Mensagem',
        route: 'list-message-types',
        perfil_id: [1, 7, 8, 20, 12],
      },
      {
        title: 'Motivos Delete',
        route: 'list-reasons-delete-calls',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Prioridades',
        route: 'list-priorities',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Tipos de sistema',
        route: 'list-project_types',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Tipos de chamados',
        route: 'list-type-calls',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Tipos de compras',
        route: 'list-purchase-types',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Tipos de Reembolsos',
        route: 'list-reimbursement-types',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Tipos de Notificação',
        route: 'list-notification-types',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Tipos de Intercorrência',
        route: 'occurrence-types',
        perfil_id: [8],
      },
      {
        title: 'Status dos Chamados',
        route: 'list-status-call',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Status dos Projetos',
        route: 'list-status-projects',
        perfil_id: [7, 8, 12],
      },
      {
        title: 'Usuários',
        route: 'list-users',
        perfil_id: [7, 8, 12],
      },
    ]
  },
  {
    title: 'Sistemas',
    route: 'list-projects',
    icon: 'CloudIcon',
    perfil_id: [1, 7, 8, 20, 12],
  },
  {
    title: 'Releases',
    route: 'releases-summary',
    icon: 'GitBranchIcon',
    perfil_id: [1, 7, 8, 10, 20, 12],
  },
  {
    title: 'Pacotes de Versões',
    route: 'list-versions',
    icon: 'HeartIcon',
    perfil_id: [1, 7, 8, 20, 12],
  },
  {
    title: 'PDF das Versões',
    route: 'list-versions-package',
    icon: 'CopyIcon',
    perfil_id: [1, 7, 8, 20, 12],
  },
  {
    title: 'Base de Conhecimentos',
    route: 'list-knowledge-bases',
    icon: 'BookOpenIcon',
    perfil_id: [1, 7, 8, 20, 12],
  },
  {
    title: 'Dashboard',
    route: 'dashboard-tv',
    icon: 'TvIcon',
    perfil_id: [1, 7, 8, 20, 12],
  },
  {
    title: 'LGPD',
    route: 'list-lgpd',
    icon: 'LockIcon',
    perfil_id: [1, 7, 8, 20, 12],
  },
  {
    title: 'Pop',
    route: 'list-procedure',
    icon: 'SettingsIcon',
    perfil_id: [1, 7, 8, 20, 12],
  }

]
